import { render, staticRenderFns } from "./AddGroups.vue?vue&type=template&id=4fed9a9a&"
import script from "./AddGroups.vue?vue&type=script&lang=js&"
export * from "./AddGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports